import { memo } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import RefreshIcon from '@mui/icons-material/Refresh'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
}

const AppVersionChanged = memo(() => {
    const onClickHandle = () => {
        window.location.reload()
    }

    return (
        <div>
            <Modal className="noPrint" open={true}>
                <Box sx={style}>
                    <Typography
                        variant="h6"
                        component="h2"
                        sx={{ textAlign: 'center' }}
                    >
                        New Version Available!
                    </Typography>
                    <Typography sx={{ mt: 2, textAlign: 'center' }}>
                        We&apos;ve updated our platform to enhance your
                        experience.
                    </Typography>
                    <Typography sx={{ mt: 1, textAlign: 'center' }}>
                        Please reload the page to enjoy the latest features and
                        improvements.
                    </Typography>
                    <Typography sx={{ mt: 2, textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            onClick={onClickHandle}
                        >
                            Refresh Page
                        </Button>
                    </Typography>
                </Box>
            </Modal>
        </div>
    )
})

export default AppVersionChanged
